import { render, staticRenderFns } from "./SchemeDetail.vue?vue&type=template&id=f86449c8&scoped=true"
import script from "./SchemeDetail.vue?vue&type=script&lang=js"
export * from "./SchemeDetail.vue?vue&type=script&lang=js"
import style0 from "./SchemeDetail.vue?vue&type=style&index=0&id=f86449c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86449c8",
  null
  
)

export default component.exports